module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.1556b14.woff";